import React from 'react';
export function Footer() {
  return <footer className="bg-[#A9D7E2] text-[#2D1F1A]/70 py-8 px-6 text-center text-sm" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <p data-id="element-60">
          © {new Date().getFullYear()} Guía Completa Para la Alimentación de Tu
          Bebé. Todos los derechos reservados.
        </p>
        <div className="mt-4 flex justify-center gap-4" data-id="element-61">
          <a href="#" className="hover:text-[#2D1F1A] transition-colors font-medium" data-id="element-62">
            Términos
          </a>
          <a href="#" className="hover:text-[#2D1F1A] transition-colors font-medium" data-id="element-63">
            Privacidad
          </a>
          <a href="#" className="hover:text-[#2D1F1A] transition-colors font-medium" data-id="element-64">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}